module.exports = __webpack_public_path__ + "static/media/road-D-photo.6351506d.svg";